import * as Types from '@theme/js/components/common/Form/types';

export const getValidationConfig = <FormValues>(
    config: Types.PValidationConfig<FormValues> | undefined,
    skipValidationFields: string[] = []
): Partial<Types.PValidationConfig<FormValues>> | undefined => {
    if (!config) {
        return config;
    }

    return Object.entries(config).reduce((acc, [key, value]) => ({
        ...acc,
        ...skipValidationFields.includes(key) ? {} : { [key]: value }
    }), {});
};
